export default __webpack_public_path__ + "static/media/Minicard_5d.4df68717.svg";